<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0026-01-0"><a id="page20"></a><a href="#/contents#fn_19" id="sn_19">DAY 19</a></p>
<p class="ct"><a href="#/contents#fn_19">WHEW! I MEAN, THANK YOU!</a></p>
<p class="ext"><span><i>God remembered Noah . . . and he sent a wind over the earth . . . The water receded steadily. . . . The ark came to rest. </i></span></p>
<p class="ext1" id="p0026-P-1"><span><i>Then God said to Noah, “Come out of the ark . . .”</i></span></p>
<p class="ext1"><span><i>So Noah came out. All the animals . . . came out of the ark. </i></span></p>
<p class="ext1" id="p0026-P-2"><span><i>Then Noah built an altar to the L<span class="small">ORD</span>.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 8:1, 3–4, 15–16, 18–20</span></p>
<p class="tx1" id="p0026-04-5"><span class="dcap">N</span>oah and his family spent a week on the ark before the rain began (Genesis 7:4). Then came forty days and forty nights of rain (v. 12), and the resulting flood lasted for a hundred and fifty days (v. 24). For another one hundred and fifty days the water steadily receded (8:3). After forty days, Noah sent a raven and then a dove for any sign that the earth was dry. Seven days later the dove went out again and this time returned with an olive leaf. Then God spoke: “Come out of the ark.”</p>
<p class="tx">What would your reaction have been? “Whew!” “Glad that’s over!” “I never want to visit a zoo as long as I live!” Noah’s reaction was none of those. He built an altar, worshiped the Lord, and thanked him for his faithfulness. A good example for all of us.</p>
<p class="tx2">MAY WE REACT TO GOD’S FAITHFULNESS NOT JUST WITH RELIEF BUT WITH REJOICING!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter22.vue?4f80f738